/**
 * Better Auth browser client, replacing the Firebase Auth compat SDK.
 *
 * Sessions are httpOnly cookies set by the Worker, so no token is ever held in
 * JavaScript -- the original kept Firebase's session in localStorage.
 */

import { createAuthClient } from 'better-auth/react';
import { emailOTPClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  basePath: '/api/auth',
  plugins: [emailOTPClient()],
});

// Annotated via `typeof authClient.*` rather than destructured: the inferred
// types reference better-auth internals that TypeScript cannot name in the
// emitted declarations (TS2742).
export const useSession: typeof authClient.useSession = authClient.useSession;
export const signIn: typeof authClient.signIn = authClient.signIn;
export const emailOtp: typeof authClient.emailOtp = authClient.emailOtp;
export const signOut: typeof authClient.signOut = authClient.signOut;
